export enum LoaderStyles {
    DualBallColored = "-dual-ball-colored",
    DualBallNeutral = "-dual-ball-neutral",
    LinkFull = "-link-full",
    LinkGlyph = "-link-glyph",
    LinkGlyphBlue = "-link-glyph-blue",
    LinkGlyphGray = "-link-glyph-gray",
    Ripple = "-ripple",
}
